import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import Icon from "components/common/Icon";
const StyledButton = styled(Button)`
  border-radius: 4px;
  min-width: 110px;
`;
const LinkLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const StepActionButton = ({
  title,
  onClick = void 0,
  to = void 0,
  disabled = false,
  hint = void 0
}) => {
  if (onClick) {
    const handleClick = (e) => {
      e.stopPropagation();
      onClick();
    };
    return /* @__PURE__ */ React.createElement(
      StyledButton,
      {
        title: hint,
        bsStyle: "gray",
        bsSize: "xs",
        "aria-label": title,
        onClick: handleClick,
        disabled
      },
      title
    );
  }
  return /* @__PURE__ */ React.createElement(
    StyledButton,
    {
      role: "link",
      bsStyle: "gray",
      bsSize: "xs",
      "aria-label": title,
      href: to,
      onClick: (e) => e.stopPropagation(),
      target: "_blank",
      rel: "noopener noreferrer",
      title: hint,
      disabled
    },
    /* @__PURE__ */ React.createElement(LinkLabel, null, title, /* @__PURE__ */ React.createElement(Icon, { name: "open_in_new", "data-testid": "open-in-new-tab-icon" }))
  );
};
export default StepActionButton;
